import { useState } from 'react';

import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  useTheme,
} from '@mui/material';
import { Search, X } from 'lucide-react';

import { outlinedInputStyles } from '@modules/_shared/components/feed-v2/components/ActivityFilters/filterSelectStyles';
import { useLocale } from '@shared/hooks/locale';

type ActivitySearchBarProps = {
  onSearch: (searchTerm: string) => void;
  onBlur: () => void;
  onClear: () => void;
};

export const ActivitySearchBar = ({
  onSearch,
  onBlur,
  onClear,
}: ActivitySearchBarProps) => {
  const { t } = useLocale();
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <OutlinedInput
      fullWidth
      autoFocus
      startAdornment={
        <InputAdornment position="start">
          <Search size={16} color={theme.palette.primary.main} />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <IconButton size="small" sx={{ borderRadius: 0.5 }} onClick={onClear}>
            <X
              size={14}
              style={{ color: (theme.vars ?? theme).palette.grey[600] }}
            />
          </IconButton>
        </InputAdornment>
      }
      placeholder={t('Search by name, address, notes, emails...')}
      value={searchTerm}
      onChange={e => {
        setSearchTerm(e.target.value);
        onSearch(e.target.value);
      }}
      onBlur={() => !searchTerm && onBlur()}
      sx={{
        fontSize: '0.875rem',
        ...outlinedInputStyles,
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'divider',
          borderWidth: 1,
        },
      }}
    />
  );
};
